import * as reviewPlaces from "./reviewPlace";
import i18n from "@/common/lang.serivce";

const ReviewPlaces = {
  list() {
    return Object.keys(reviewPlaces);
  },
  getAll() {
    return this.list().map(reviewPlace => {
      return {
        value: reviewPlace,
        text: i18n.t("reviewPlaces." + reviewPlace)
      };
    });
  }
};

export default ReviewPlaces;
